export const LANGUAGES = [
  { code: 'NL', label: 'Nederlands', short: 'NL' },
  { code: 'EN', label: 'English', short: 'EN' },
  { code: 'ES', label: 'Español', short: 'ES' },
];

export const translations = {
  NL: {
    nav: {
      services: 'Diensten',
      about: 'Wie zijn wij',
      trust: 'Vertrouwen',
      contact: 'Contact',
      cta: 'Contact opnemen',
    },
    hero: {
      eyebrow: 'KeyHolding & Property Management · Costa Blanca',
      headline: 'Uw vastgoed aan de Costa Blanca, zorgeloos beheerd en verhuurd.',
      tagline: 'Maximaal rendement uit uw Spaanse woning, zonder de operationele stress.',
      sub: 'Het bezitten van een tweede thuis in Spanje is een droom. Het beheer ervan op afstand vaak een uitdaging. Casa Serena neemt al uw zorgen uit handen. Wij spreken uw taal en fungeren als uw betrouwbare aanspreekpunt ter plaatse. Van proactief onderhoud tot het complete boekingsproces: uw vastgoed is bij ons in veilige handen.',
      servicesTitle: 'Wat wij voor u regelen',
      services: [
        { title: 'Volledige Airbnb verhuur service', body: 'Van gastenontvangst tot de eindschoonmaak.' },
        { title: 'Betrouwbaar sleutelbeheer', body: 'Veilige opslag en flexibele overdracht van uw sleutels.' },
        { title: 'Periodieke woningcontroles', body: 'Regelmatige inspecties op stormschade, lekkages en installaties.' },
        { title: 'Lokale netwerken', body: 'Directe toegang tot gecertificeerde klusjesmannen en schoonmakers.' },
      ],
      cta: 'Ja, ik wil zorgeloos verhuren',
      meta: 'Officiële start februari 2027 · Persoonlijk contact · Nederlandstalig',
    },
    pain: {
      eyebrow: 'De realiteit van een tweede huis',
      title: 'Wel de lusten, niet de lasten',
      intro: 'Een eigen huis in het buitenland is een droom, tot er op afstand iets geregeld moet worden. Grote afstand brengt vaak onnodige zorgen met zich mee. Wij nemen al het werk en beheer volledig van u over, zodat u alleen nog maar hoeft te genieten.',
      worries: [
        { title: 'Controle na slecht weer', body: 'Trekt er een storm over de regio? U hoeft zich geen zorgen te maken over schade aan uw huis of terras. Wij gaan binnen 48 uur zelf langs om alles te controleren. Deze controle zit standaard in onze service.' },
        { title: 'Directe hulp bij een alarm', body: 'Gaat het alarm midden in de nacht af? Geen paniek op afstand. Uw vaste contactpersoon rijdt meteen naar uw woning om te kijken wat er aan de hand is. U krijgt direct foto\u2019s of video\u2019s via uw mobiel.' },
        { title: 'Altijd een schone woning', body: 'Komt de schoonmaker plotseling niet opdagen? Wij lossen het op. Wij werken alleen met een vast team van professionele en betrouwbare schoonmakers. Zo bent u altijd zeker van een schoon huis voor uw gasten.' },
        { title: 'Regelmatige controle en beheer', body: 'Wij voorkomen grote problemen zoals lekkages, vocht of ongedierte. We controleren uw woning eens per maand, spoelen de leidingen door om legionella te voorkomen, verwerken uw post en lossen kleine problemen op voordat ze erger worden.' },
      ],
    },
    services: {
      eyebrow: 'Onze pakketten',
      title: 'Twee duidelijke pakketten.',
      intro: 'Of u uw woning alleen voor uzelf gebruikt of via Airbnb verhuurt, wij hebben de juiste oplossing. Bekijk welk pakket het beste bij uw situatie past.',
      a: {
        tag: 'Pakket 1',
        title: 'Woningbeheer & Controle',
        subtitle: 'Voor woningen die niet verhuurd worden',
        description: 'Dit pakket is ideaal als u uw woning in Spanje alleen voor uzelf gebruikt en niet verhuurt. Wij houden een oogje in het zeil als u er niet bent. U bent verzekerd van regelmatige inspecties, snelle hulp bij een alarm en directe controle na slecht weer. Uw kostbare bezit is in veilige handen, zodat u op afstand gerust bent.',
        bullets: [
          'Maandelijkse woninginspectie',
          'Snelle hulp bij een alarm',
          'Directe controle na slecht weer',
          'Doorspoelen leidingen tegen legionella',
          'Foto en video updates via WhatsApp',
          'Vast persoonlijk aanspreekpunt',
        ],
      },
      b: {
        tag: 'Pakket 2',
        title: 'Volledig Airbnb Co-Hosting & Verhuur',
        subtitle: 'Wij beheren uw verhuur op Airbnb en Booking.com',
        description: 'Wilt u zorgeloos rendement behalen uit uw woning? Wij treden op als uw professionele co-host voor Airbnb. Naast het volledige beheer en de inspecties uit Pakket 1, regelen wij alles voor uw gasten. Van de communicatie en de sleuteloverdracht tot een vlekkeloze schoonmaak en de was. U de inkomsten, wij het werk.',
        bullets: [
          'Alles uit Pakket 1 inbegrepen',
          'Volledig beheer van Airbnb en Booking.com',
          'Persoonlijke gastencommunicatie',
          'Sleuteloverdracht en ontvangst van gasten',
          'Coördinatie van schoonmaak en wasservice',
          'U de inkomsten, wij het werk',
        ],
      },
      cta: 'Bespreek het juiste pakket',
    },
    about: {
      eyebrow: 'Persoonlijk',
      button: 'Plan een vrijblijvend kennismakingsgesprek',
      title: 'Wie zijn wij',
      paragraphs: [
        'Wij zijn Luuk en Kika, een enthousiast en getrouwd stel met een grote passie voor Spanje. Wij zijn permanent gevestigd aan de Costa Blanca in de regio Alicante. Met onze achtergrond in de zorg en accountmanagement combineren wij het beste van twee werelden: absolute zorgvuldigheid, betrouwbaarheid en een sterke, klantgerichte communicatie.',
        'Wat ons onderscheidt is onze persoonlijke en professionele aanpak. Wij begrijpen dat uw woning in Spanje een kostbaar bezit is. Daarom reageren wij altijd snel en werken wij uitsluitend met de beste lokale specialisten. Met ons heeft u geen anoniem bedrijf aan de lijn, maar twee gedreven professionals die uw woning beheren alsof het hun eigen huis is. Zo kunt u met een gerust hart genieten, waar u op dat moment ook bent.',
      ],
      signature: 'Luuk & Kika',
      signatureRole: 'Casa Serena',
    },
    trust: {
      eyebrow: 'Professioneel en betrouwbaar',
      title: 'Officieel, verzekerd en professioneel vanaf dag één',
      body: 'Op 1 februari 2027 starten wij Casa Serena officieel: geregistreerd in Spanje, met een volledige bedrijfsaansprakelijkheidsverzekering (Responsabilidad Civil) en een vast team van betrouwbare vakmensen om ons heen. Wij werken met duidelijke checklists, sturen u digitale rapporten en leggen alle afspraken persoonlijk en schriftelijk vast. Geen informeel gedoe, gewoon een solide fundament vanaf de eerste dag.',
      pills: ['Verzekerd bij start (RC)', 'Geregistreerd in Spanje', 'Vaste inspectieprotocollen', 'Officiële start februari 2027'],
    },
    contact: {
      eyebrow: 'Een digitaal kopje koffie',
      title: 'Vertel ons over uw villa of appartement.',
      sub: 'Geen verkoopgesprek. Wel een persoonlijk, vrijblijvend gesprek waarin we luisteren naar uw situatie en eerlijk vertellen of wij de juiste partij zijn.',
      labels: { name: 'Uw naam', email: 'Emailadres', phone: 'Telefoonnummer', message: 'Vertel ons kort over uw woning' },
      placeholders: { name: 'Bv. Jan de Vries', email: 'naam@voorbeeld.nl', phone: '+31 6 1234 5678', message: 'Locatie, type woning, wat u zoekt…' },
      cta: 'Plan een vrijblijvend kennismakingsgesprek',
      sending: 'Versturen…',
      success: 'Bedankt, wij nemen binnen 24 uur persoonlijk contact op.',
      error: 'Er ging iets mis. Probeer het opnieuw of stuur ons een WhatsApp bericht.',
      legal: 'Wij delen uw gegevens nooit. U ontvangt geen nieuwsbrieven, alleen een persoonlijk antwoord.',
    },
    footer: {
      tagline: 'Sleutelbeheer en verhuurontzorging voor eigenaren in de regio Alicante.',
      rights: 'Alle rechten voorbehouden.',
      legalNote: 'Casa Serena · Registratie in Spanje vanaf februari 2027 · Volledig verzekerd bij start (Responsabilidad Civil).',
    },
    whatsapp: 'Chat met ons op WhatsApp',
    trustBadges: {
      items: [
        'Officiële start februari 2027',
        'Verzekerd bij start (RC)',
        'Reactie binnen 48 uur bij alarm',
        'Lokaal Nederlandstalig team',
      ],
    },
    testimonials: {
      eyebrow: 'Wat eigenaren zeggen',
      title: 'Rust, vertrouwen en persoonlijk contact.',
      disclaimer: 'Voorbeeldreferenties. Echte testimonials worden gepubliceerd na onze officiële start in februari 2027.',
      items: [
        {
          quote: 'Sinds Casa Serena mijn appartement in Altea beheert, slaap ik pas echt rustig. Na een storm heb ik binnen 48 uur foto\u2019s op mijn telefoon. Onvoorstelbaar prettig.',
          name: 'Familie Sanders',
          location: 'Altea',
        },
        {
          quote: 'Luuk en Kika denken écht met je mee. Toen mijn schoonmaakster onverwacht uitviel, hadden zij binnen een dag een vervanger. Persoonlijk en professioneel.',
          name: 'Peter en Marja de Vries',
          location: 'Moraira',
        },
        {
          quote: 'Als co-host voor Airbnb is Casa Serena goud waard. Betere reviews, meer boekingen en ik heb er zelf geen omkijken meer naar.',
          name: 'Familie Bakker',
          location: 'Jávea',
        },
      ],
    },
    legal: {
      privacyLink: 'Privacybeleid',
      privacyTitle: 'Privacybeleid',
      privacyBody: [
        'Casa Serena verwerkt uw persoonsgegevens uitsluitend om uw aanvraag te beantwoorden en onze dienstverlening te leveren. Wij delen uw gegevens nooit met derden zonder uw uitdrukkelijke toestemming.',
        'U kunt op elk moment inzage, correctie of verwijdering van uw gegevens aanvragen via info@casaserena.es. Wij bewaren uw gegevens niet langer dan nodig voor het doel waarvoor ze verzameld zijn.',
        'Deze privacyverklaring wordt bij onze officiële start in februari 2027 aangevuld met de definitieve juridische tekst, inclusief onze registratiegegevens.',
      ],
      termsLink: 'Algemene Voorwaarden',
      termsTitle: 'Algemene Voorwaarden',
      termsBody: [
        'De volledige algemene voorwaarden van Casa Serena worden gepubliceerd bij onze officiële start in februari 2027.',
        'Tot dat moment gelden onze diensten op basis van individuele schriftelijke afspraken die persoonlijk met u worden vastgelegd tijdens het kennismakingsgesprek.',
        'Voor vragen over onze voorwaarden of dienstverlening kunt u altijd contact opnemen via info@casaserena.es.',
      ],
    },
  },

  EN: {
    nav: {
      services: 'Services',
      about: 'About us',
      trust: 'Trust',
      contact: 'Contact',
      cta: 'Get to know us',
    },
    hero: {
      eyebrow: 'KeyHolding & Property Management · Costa Blanca',
      headline: 'Your Costa Blanca property, seamlessly managed and rented.',
      tagline: 'Maximum return on your Spanish home, without the operational stress.',
      sub: 'Owning a second home in Spain is a dream. Managing it from a distance is often a challenge. Casa Serena takes all your worries off your hands. We speak your language and act as your reliable point of contact on site. From proactive maintenance to the complete booking process: your property is in safe hands with us.',
      servicesTitle: 'What we arrange for you',
      services: [
        { title: 'Complete Airbnb rental service', body: 'From guest reception to the final clean.' },
        { title: 'Reliable keyholding', body: 'Secure storage and flexible handover of your keys.' },
        { title: 'Regular property checks', body: 'Routine inspections for storm damage, leaks and utilities.' },
        { title: 'Local networks', body: 'Direct access to certified handymen and cleaners.' },
      ],
      cta: 'Yes, I want worry free rental',
      meta: 'Official launch February 2027 · Personal contact · Dutch speaking',
    },
    pain: {
      eyebrow: 'The reality of a second home',
      title: 'All the perks, none of the hassle',
      intro: 'Owning a home abroad is a dream, until something has to be arranged from a distance. Long distance often brings unnecessary worries. We take all the work and management completely off your hands, so all you have to do is enjoy it.',
      worries: [
        { title: 'Inspections after bad weather', body: 'A storm passing through the region? You do not need to worry about damage to your home or terrace. We personally drive by within 48 hours to check everything. This inspection is included as standard in our service.' },
        { title: 'Immediate response to an alarm', body: 'Alarm going off in the middle of the night? No remote panic. Your dedicated contact drives straight to your property to see what is happening. You receive photos or videos directly on your phone.' },
        { title: 'Always a spotless home', body: 'The cleaner suddenly did not show up? We fix it. We work exclusively with a fixed team of professional and reliable cleaners. So you are always assured of a clean home for your guests.' },
        { title: 'Regular checks and management', body: 'We prevent major issues like leaks, damp or pests. We inspect your property once a month, flush the pipes to prevent legionella, handle your post and resolve small problems before they grow into bigger ones.' },
      ],
    },
    services: {
      eyebrow: 'Our packages',
      title: 'Two clear packages.',
      intro: 'Whether you use your home only for yourself or rent it out via Airbnb, we have the right solution. See which package fits your situation best.',
      a: {
        tag: 'Package 1',
        title: 'Property Management & Care',
        subtitle: 'For homes that are not rented out',
        description: 'This package is ideal if you use your home in Spain only for yourself and do not rent it out. We keep an eye on things when you are not there. You are assured of regular inspections, swift response to alarms and immediate checks after bad weather. Your valuable property is in safe hands, so you have peace of mind from afar.',
        bullets: [
          'Monthly property inspection',
          'Swift response to alarms',
          'Immediate checks after bad weather',
          'Pipe flushing to prevent legionella',
          'Photo and video updates via WhatsApp',
          'One personal point of contact',
        ],
      },
      b: {
        tag: 'Package 2',
        title: 'Full Airbnb Co-Hosting & Rental',
        subtitle: 'We manage your rental on Airbnb and Booking.com',
        description: 'Would you like a hassle free return on your property? We act as your professional co-host for Airbnb. In addition to the full management and inspections from Package 1, we take care of everything for your guests. From communication and key handover to spotless cleaning and laundry. You get the income, we do the work.',
        bullets: [
          'Everything from Package 1 included',
          'Full management of Airbnb and Booking.com',
          'Personal guest communication',
          'Key handover and guest welcome',
          'Coordination of cleaning and laundry',
          'You get the income, we do the work',
        ],
      },
      cta: 'Discuss the right package',
    },
    about: {
      eyebrow: 'Personal',
      button: 'Book a free introduction call',
      title: 'Who we are',
      paragraphs: [
        'We are Luuk and Kika, an enthusiastic and married couple with a great passion for Spain. We are permanently based on the Costa Blanca, in the Alicante region. With our backgrounds in healthcare and account management, we combine the best of two worlds: absolute care, reliability and strong, client focused communication.',
        'What sets us apart is our personal and professional approach. We understand that your home in Spain is a precious asset. That is why we always respond quickly and work only with the best local specialists. With us you do not have an anonymous company on the line, but two driven professionals who manage your home as if it were their own. So you can enjoy with complete peace of mind, wherever you happen to be.',
      ],
      signature: 'Luuk & Kika',
      signatureRole: 'Casa Serena',
    },
    trust: {
      eyebrow: 'Professional and reliable',
      title: 'Official, insured and professional',
      body: 'We are officially registered in Spain and we have proper business liability insurance. With us you are in safe hands. We work with clear checklists, send you digital reports and have a fixed team of reliable craftsmen around us. No vague agreements or informal hassle, just solid and professional service you can build on.',
      pills: ['Fully insured (RC)', 'Officially registered in Spain', 'Fixed inspection protocols', 'Automated reporting'],
    },
    contact: {
      eyebrow: 'A digital coffee',
      title: 'Tell us about your villa or apartment.',
      sub: 'Not a sales pitch. A personal, free conversation where we listen to your situation and honestly tell you whether we are the right partner.',
      labels: { name: 'Your name', email: 'Email address', phone: 'Phone number', message: 'Tell us briefly about your property' },
      placeholders: { name: 'E.g. John Smith', email: 'name@example.com', phone: '+44 7700 900123', message: 'Location, type of property, what you are looking for…' },
      cta: 'Book a free introduction call',
      sending: 'Sending…',
      success: 'Thank you, we will personally reach out within 24 hours.',
      error: 'Something went wrong. Please try again or send us a WhatsApp message.',
      legal: 'We never share your data. No newsletters, only a personal reply.',
    },
    footer: {
      tagline: 'Keyholding and rental management for owners in the Alicante region.',
      rights: 'All rights reserved.',
      legalNote: 'Casa Serena · Registered in Spain from February 2027 · Fully insured at launch (Responsabilidad Civil).',
    },
    whatsapp: 'Chat with us on WhatsApp',
    trustBadges: {
      items: [
        'Official launch February 2027',
        'Insured at launch (RC)',
        '48 hour alarm response',
        'Local Dutch speaking team',
      ],
    },
    testimonials: {
      eyebrow: 'What owners say',
      title: 'Peace of mind, trust and personal contact.',
      disclaimer: 'Sample testimonials. Real client stories will be published after our official launch in February 2027.',
      items: [
        {
          quote: 'Since Casa Serena has been managing my apartment in Altea, I finally sleep peacefully. Within 48 hours of a storm I have photos on my phone. Incredibly reassuring.',
          name: 'The Sanders Family',
          location: 'Altea',
        },
        {
          quote: 'Luuk and Kika truly think along with you. When my cleaner unexpectedly could not come, they had a replacement within a day. Personal and professional.',
          name: 'Peter and Marja de Vries',
          location: 'Moraira',
        },
        {
          quote: 'As an Airbnb co-host, Casa Serena is worth its weight in gold. Better reviews, more bookings and I no longer have to worry about a thing.',
          name: 'The Bakker Family',
          location: 'Jávea',
        },
      ],
    },
    legal: {
      privacyLink: 'Privacy Policy',
      privacyTitle: 'Privacy Policy',
      privacyBody: [
        'Casa Serena processes your personal data solely to respond to your enquiry and provide our services. We never share your data with third parties without your explicit consent.',
        'You can request access, correction or deletion of your data at any time via info@casaserena.es. We do not retain your data longer than necessary for the purpose for which it was collected.',
        'This privacy statement will be supplemented with the final legal text and our registration details upon our official launch in February 2027.',
      ],
      termsLink: 'Terms and Conditions',
      termsTitle: 'Terms and Conditions',
      termsBody: [
        'The full terms and conditions of Casa Serena will be published upon our official launch in February 2027.',
        'Until then, our services are provided on the basis of individual written agreements established personally with you during the introduction call.',
        'For questions about our terms or services please contact us at info@casaserena.es.',
      ],
    },
  },

  ES: {
    nav: {
      services: 'Servicios',
      about: 'Quiénes somos',
      trust: 'Confianza',
      contact: 'Contacto',
      cta: 'Contactar',
    },
    hero: {
      eyebrow: 'Custodia de llaves y gestión de propiedades · Costa Blanca',
      headline: 'Su propiedad en la Costa Blanca, gestionada y alquilada sin preocupaciones.',
      tagline: 'Máxima rentabilidad de su vivienda en España, sin el estrés operativo.',
      sub: 'Tener una segunda residencia en España es un sueño. Gestionarla a distancia, a menudo un reto. Casa Serena se encarga de todas sus preocupaciones. Hablamos su idioma y actuamos como su contacto de confianza sobre el terreno. Desde el mantenimiento proactivo hasta el proceso completo de reservas: su propiedad está en buenas manos con nosotros.',
      servicesTitle: 'Lo que gestionamos para usted',
      services: [
        { title: 'Servicio completo de alquiler Airbnb', body: 'Desde la recepción del huésped hasta la limpieza final.' },
        { title: 'Custodia fiable de llaves', body: 'Almacenamiento seguro y entrega flexible de sus llaves.' },
        { title: 'Revisiones periódicas de la vivienda', body: 'Inspecciones habituales por daños de tormentas, fugas e instalaciones.' },
        { title: 'Redes locales', body: 'Acceso directo a manitas y personal de limpieza certificados.' },
      ],
      cta: 'Sí, quiero alquilar sin preocupaciones',
      meta: 'Lanzamiento oficial febrero 2027 · Contacto personal · Habla neerlandés',
    },
    pain: {
      eyebrow: 'La realidad de una segunda residencia',
      title: 'Todas las ventajas, ninguna de las preocupaciones',
      intro: 'Tener una casa propia en el extranjero es un sueño, hasta que hay que resolver algo a distancia. La lejanía suele traer preocupaciones innecesarias. Nosotros asumimos toda la gestión y el trabajo, para que usted solo tenga que disfrutar.',
      worries: [
        { title: 'Revisión tras el mal tiempo', body: '¿Cruza una tormenta por la región? No tiene que preocuparse por daños en su casa o terraza. Pasamos personalmente en menos de 48 horas para revisarlo todo. Esta inspección está incluida de serie en nuestro servicio.' },
        { title: 'Respuesta inmediata ante una alarma', body: '¿Suena la alarma en plena madrugada? Nada de pánico a distancia. Su contacto fijo se desplaza de inmediato a su propiedad para ver qué ocurre. Recibe directamente fotos o vídeos en su móvil.' },
        { title: 'Una casa siempre impecable', body: '¿La persona de limpieza no aparece de repente? Lo solucionamos. Trabajamos únicamente con un equipo fijo de profesionales de limpieza fiables. Así siempre tendrá la certeza de una casa limpia para sus huéspedes.' },
        { title: 'Control y mantenimiento periódico', body: 'Evitamos grandes problemas como fugas, humedad o plagas. Inspeccionamos su propiedad una vez al mes, purgamos las tuberías para prevenir la legionela, gestionamos su correo y resolvemos pequeñas incidencias antes de que se conviertan en algo mayor.' },
      ],
    },
    services: {
      eyebrow: 'Nuestros paquetes',
      title: 'Dos paquetes claros.',
      intro: 'Tanto si utiliza su vivienda solo para usted como si la alquila a través de Airbnb, tenemos la solución adecuada. Vea cuál encaja mejor con su situación.',
      a: {
        tag: 'Paquete 1',
        title: 'Gestión y Cuidado de la Vivienda',
        subtitle: 'Para viviendas que no se alquilan',
        description: 'Este paquete es ideal si utiliza su vivienda en España solo para usted y no la alquila. Estamos atentos cuando usted no está. Le garantizamos inspecciones periódicas, respuesta rápida ante alarmas y revisión inmediata tras el mal tiempo. Su valiosa propiedad está en buenas manos, para que esté tranquilo desde la distancia.',
        bullets: [
          'Inspección mensual de la vivienda',
          'Respuesta rápida ante alarmas',
          'Revisión inmediata tras el mal tiempo',
          'Purga de tuberías para prevenir la legionela',
          'Fotos y vídeos por WhatsApp',
          'Un único contacto personal',
        ],
      },
      b: {
        tag: 'Paquete 2',
        title: 'Co-Hosting & Alquiler Completo en Airbnb',
        subtitle: 'Gestionamos su alquiler en Airbnb y Booking.com',
        description: '¿Quiere obtener rentabilidad de su vivienda sin preocupaciones? Actuamos como su co-host profesional en Airbnb. Además de la gestión completa y las inspecciones del Paquete 1, nos encargamos de todo lo relacionado con sus huéspedes. Desde la comunicación y la entrega de llaves hasta una limpieza impecable y la lavandería. Usted los ingresos, nosotros el trabajo.',
        bullets: [
          'Todo lo del Paquete 1 incluido',
          'Gestión completa de Airbnb y Booking.com',
          'Comunicación personal con los huéspedes',
          'Entrega de llaves y recepción de los huéspedes',
          'Coordinación de limpieza y lavandería',
          'Usted los ingresos, nosotros el trabajo',
        ],
      },
      cta: 'Hablemos del paquete adecuado',
    },
    about: {
      eyebrow: 'Personal',
      button: 'Reserve una consulta sin compromiso',
      title: 'Quiénes somos',
      paragraphs: [
        'Somos Luuk y Kika, una pareja entusiasta y casada con una gran pasión por España. Estamos establecidos de forma permanente en la Costa Blanca, en la región de Alicante. Con nuestra trayectoria en el sector sanitario y en la gestión de cuentas, combinamos lo mejor de dos mundos: máxima diligencia, fiabilidad y una comunicación clara y orientada al cliente.',
        'Lo que nos distingue es nuestro enfoque personal y profesional. Entendemos que su vivienda en España es un bien valioso. Por eso respondemos siempre con rapidez y trabajamos únicamente con los mejores especialistas locales. Con nosotros no tendrá a una empresa anónima al otro lado, sino a dos profesionales comprometidos que cuidan de su casa como si fuese la suya propia. Así podrá disfrutar con total tranquilidad, esté donde esté.',
      ],
      signature: 'Luuk & Kika',
      signatureRole: 'Casa Serena',
    },
    trust: {
      eyebrow: 'Profesional y de confianza',
      title: 'Oficial, asegurada y profesional desde el primer día',
      body: 'El 1 de febrero de 2027 lanzamos oficialmente Casa Serena: registrada en España, con un seguro completo de responsabilidad civil y un equipo fijo de profesionales de confianza a nuestro alrededor. Trabajamos con checklists claros, le enviamos informes digitales y ponemos por escrito, de forma personal, todos los acuerdos. Nada de informalidades, solo una base sólida desde el primer día.',
      pills: ['Asegurada en el lanzamiento (RC)', 'Registrada en España', 'Protocolos de inspección fijos', 'Lanzamiento oficial febrero 2027'],
    },
    contact: {
      eyebrow: 'Un café digital',
      title: 'Cuéntenos sobre su villa o apartamento.',
      sub: 'No es una llamada comercial. Es una conversación personal y sin compromiso donde escuchamos su situación y le decimos con honestidad si somos la opción adecuada.',
      labels: { name: 'Su nombre', email: 'Correo electrónico', phone: 'Teléfono', message: 'Cuéntenos brevemente sobre su propiedad' },
      placeholders: { name: 'Ej. María García', email: 'nombre@ejemplo.es', phone: '+34 600 123 456', message: 'Ubicación, tipo de vivienda, lo que busca…' },
      cta: 'Reserve una consulta sin compromiso',
      sending: 'Enviando…',
      success: 'Gracias, nos pondremos en contacto personalmente en 24 horas.',
      error: 'Algo salió mal. Inténtelo de nuevo o escríbanos por WhatsApp.',
      legal: 'Nunca compartimos sus datos. Sin newsletters, solo una respuesta personal.',
    },
    footer: {
      tagline: 'Custodia de llaves y gestión de alquiler para propietarios en la región de Alicante.',
      rights: 'Todos los derechos reservados.',
      legalNote: 'Casa Serena · Registro en España desde febrero 2027 · Totalmente asegurada en el lanzamiento (Responsabilidad Civil).',
    },
    whatsapp: 'Chatee con nosotros por WhatsApp',
    trustBadges: {
      items: [
        'Lanzamiento oficial febrero 2027',
        'Asegurada en el lanzamiento (RC)',
        'Respuesta a alarmas en 48 horas',
        'Equipo local que habla neerlandés',
      ],
    },
    testimonials: {
      eyebrow: 'Lo que dicen los propietarios',
      title: 'Tranquilidad, confianza y contacto personal.',
      disclaimer: 'Testimonios de ejemplo. Las reseñas reales se publicarán tras nuestro lanzamiento oficial en febrero de 2027.',
      items: [
        {
          quote: 'Desde que Casa Serena gestiona mi apartamento en Altea, por fin duermo tranquilo. En menos de 48 horas tras una tormenta ya tengo las fotos en el móvil. Increíblemente tranquilizador.',
          name: 'Familia Sanders',
          location: 'Altea',
        },
        {
          quote: 'Luuk y Kika piensan realmente contigo. Cuando mi limpiadora no pudo venir de repente, en un día tenían una sustituta. Personal y profesional.',
          name: 'Peter y Marja de Vries',
          location: 'Moraira',
        },
        {
          quote: 'Como co-host de Airbnb, Casa Serena vale su peso en oro. Mejores reseñas, más reservas y yo no tengo que preocuparme por nada.',
          name: 'Familia Bakker',
          location: 'Jávea',
        },
      ],
    },
    legal: {
      privacyLink: 'Política de Privacidad',
      privacyTitle: 'Política de Privacidad',
      privacyBody: [
        'Casa Serena trata sus datos personales exclusivamente para responder a su consulta y prestar nuestros servicios. Nunca compartimos sus datos con terceros sin su consentimiento expreso.',
        'Puede solicitar acceso, rectificación o eliminación de sus datos en cualquier momento a través de info@casaserena.es. No conservamos sus datos más tiempo del necesario para la finalidad para la que fueron recogidos.',
        'Esta declaración de privacidad se completará con el texto legal definitivo y nuestros datos de registro tras el lanzamiento oficial en febrero de 2027.',
      ],
      termsLink: 'Términos y Condiciones',
      termsTitle: 'Términos y Condiciones',
      termsBody: [
        'Los términos y condiciones completos de Casa Serena se publicarán con motivo de nuestro lanzamiento oficial en febrero de 2027.',
        'Hasta entonces, nuestros servicios se prestan sobre la base de acuerdos individuales por escrito establecidos personalmente con usted durante la consulta inicial.',
        'Para cualquier consulta sobre nuestros términos o servicios puede escribirnos a info@casaserena.es.',
      ],
    },
  },
};

export const getT = (lang) => translations[lang] || translations.NL;
